import { motion } from 'framer-motion'
import Link from './Link'
import { getCategories } from '../data/products'

const Portfolio = () => {
  const categoryMeta = getCategories()

  return (
    <section id="portfolio" className="bg-[#f7f8f5] py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55 }}
          viewport={{ once: true }}
          className="mx-auto max-w-3xl text-center"
        >
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-teal-700">
            Product Categories
          </p>
          <h2 className="mt-4 text-4xl font-semibold leading-tight text-slate-950 md:text-5xl">
            Browse our prosthetic product categories.
          </h2>
          <p className="mt-5 text-lg leading-8 text-slate-600">
            Select a category to view the full range of products within it.
          </p>
        </motion.div>

        <div className="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {categoryMeta.map(({ category, slug, representative, count }, index) => (
            <motion.article
              key={slug}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: Math.min(index * 0.04, 0.24) }}
              viewport={{ once: true }}
              className="group overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm transition-shadow hover:shadow-xl hover:shadow-slate-200/80"
            >
              <Link
                to={`/category/${slug}`}
                className="block bg-gradient-to-b from-white to-slate-50 p-6"
                ariaLabel={`View all ${category} products`}
              >
                <img
                  src={representative.image}
                  alt={representative.alt}
                  loading="lazy"
                  width={310}
                  height={310}
                  className="mx-auto aspect-square w-full max-w-[310px] object-contain transition-transform duration-300 group-hover:scale-[1.03]"
                />
              </Link>
              <div className="border-t border-slate-100 p-6 text-center">
                <h3 className="text-2xl font-semibold leading-tight text-slate-950">
                  <Link
                    to={`/category/${slug}`}
                    className="transition-colors hover:text-teal-700"
                  >
                    {category}
                  </Link>
                </h3>
                <p className="mt-2 text-sm text-slate-500">
                  {count} {count === 1 ? 'product' : 'products'}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Portfolio
